export default __webpack_public_path__ + "static/media/IMG_7343.b2446e6d.jpg";